"use client";

import { useEffect } from "react";

import { AlertTriangle } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export default function AppError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // In a real app, you would log this to an error reporting service
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Alert className="max-w-2xl">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>Application Error</AlertTitle>
        <AlertDescription className="mt-2">
          <p className="mb-4">An error occurred while loading this page. Our team has been notified.</p>
          {process.env.NODE_ENV === "development" && (
            <div className="mb-4 rounded-md bg-muted p-3">
              <p className="font-mono text-sm">{error.message}</p>
              {error.digest && <p className="mt-2 font-mono text-xs text-muted-foreground">Error ID: {error.digest}</p>}
            </div>
          )}
          <Button onClick={reset} variant="default">
            Try again
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  );
}
